import React, { useEffect, useState, useMemo } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import axiosInstance from "../../services/auth";
import { useCombinedContext } from "../../context/CombinedContext";
import profile from "../../assets/profile.png";

const ProfileDropdown = () => {
  const navigate = useNavigate();
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [currentUser, setCurrentUser] = useState(null);
  const { user, setUser } = useCombinedContext();

  const authData = useMemo(() => {
    return (
      JSON.parse(localStorage.getItem("authData")) ||
      JSON.parse(sessionStorage.getItem("authData"))
    );
  }, []);

  useEffect(() => {
    if (!authData) {
      toast.error("User session expired. Please log in again.");
      navigate("/login", { replace: true });
      return;
    }

    const fetchUser = async () => {
      try {
        const { data } = await axiosInstance.get("/auth/profile");
        setUser(data.data);
      } catch (error) {
        // console.error("Fetch user error:", error);
        toast.error("Error fetching profile");
      }
    };

    fetchUser();
  }, [authData, navigate]);

  // Close dropdown if clicked outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (!event.target.closest(".dropdown")) {
        setDropdownOpen(false);
      }
    };

    document.addEventListener("click", handleClickOutside);

    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, []);

  const toggleDropdown = () => setDropdownOpen((prev) => !prev);

  const handleMenuItemClick = (path) => {
    setDropdownOpen(false);
    navigate(path);
  };

  const handleLogout = (path) => {
    navigate(path);
  };

  if (!authData) {
    return null;
  }

  return (
    <div className="dropdown">
      <a
        className="nav-link d-flex align-items-center no-arrow"
        href="#"
        id="profileDropdown"
        role="button"
        aria-expanded={dropdownOpen}
        onClick={toggleDropdown}
      >
        <img
          src={
            user?.image
              ? `${axiosInstance.defaults.baseURL}/Uploads/${user.image}`
              : `${profile}`
          }
          alt="Profile"
          className="rounded-circle me-2"
          style={{ width: "30px", height: "30px" }}
        />
        <span>{user?.name || "User Name"}</span>
      </a>
      <ul
        className={`dropdown-menu dropdown-menu-end ${dropdownOpen ? "show" : ""}`}
        aria-labelledby="profileDropdown"
      >
        <li>
          <button
            className="dropdown-item"
            onClick={() => handleMenuItemClick("/profile")}
          >
            <i className="bi bi-person me-2"></i> Profile
          </button>
        </li>
        <li>
          <hr className="dropdown-divider" />
        </li>
        <li>
          <button
            className="dropdown-item text-danger"
            onClick={() => handleLogout("/logout")}
          >
            <i className="bi bi-box-arrow-right me-2"></i> Log out
          </button>
        </li>
      </ul>
    </div>
  );
};

export default ProfileDropdown;
